module.exports = __webpack_public_path__ + "static/hero-image-desktop-7c91a99b0a17961fb784e021eaaced25.svg";